module.exports = __webpack_public_path__ + "static/media/warning.ac39fdc8.svg";